import type { TableFilter } from '../client/db-adapter.js'

/**
 * `filters` without the ones on `gone` columns (#899), keeping the meaning
 * of what is left.
 *
 * Filters group by `logic`: an `or` starts a group and the rest join the one
 * before it — `A, B(or), C(and)` is `A OR (B AND C)` (the server's
 * `buildWhereFromFilters`, the filter panel). Dropping a filter that STARTS
 * a group hands the start to the next one kept from that group; otherwise
 * `A OR (B AND C)` losing B would quietly read `A AND C`. The first filter
 * kept carries no logic. The same array comes back when nothing is dropped.
 */
export function withoutFilterColumns(filters: TableFilter[], gone: ReadonlySet<string>): TableFilter[] {
  if (!filters.some(f => gone.has(f.column))) return filters
  const kept: TableFilter[] = []
  let carryGroupStart = false
  filters.forEach((f, i) => {
    const startsGroup = i === 0 || f.logic === 'or'
    if (gone.has(f.column)) { if (startsGroup) carryGroupStart = true; return }
    const heads = startsGroup || carryGroupStart
    carryGroupStart = false
    const logic: TableFilter['logic'] = kept.length === 0 ? undefined : heads ? 'or' : 'and'
    kept.push(logic === (f.logic ?? (i === 0 ? undefined : 'and')) ? f : { ...f, logic })
  })
  return kept
}
